import {
  ExecutionHistorySummary,
  ExecutionHistoryDetail,
  ExecutionHistorySearchRequest,
  ExecutionHistorySearchResponse,
  ExecutionScoreSummary,
} from '../types/executionHistory';
import { authenticatedAxios } from './axiosConfig';

export class ExecutionHistoryService {
  private static instance: ExecutionHistoryService;

  private constructor() {}

  public static getInstance(): ExecutionHistoryService {
    if (!ExecutionHistoryService.instance) {
      ExecutionHistoryService.instance = new ExecutionHistoryService();
    }
    return ExecutionHistoryService.instance;
  }

  async getExecutionById(executionId: string): Promise<ExecutionHistoryDetail> {
    const response = await authenticatedAxios.get<ExecutionHistoryDetail>(
      `/ExecutionHistory/${executionId}`
    );
    return response.data;
  }

  async searchExecutions(
    request: ExecutionHistorySearchRequest
  ): Promise<ExecutionHistorySearchResponse> {
    const response = await authenticatedAxios.post<ExecutionHistorySearchResponse>(
      '/ExecutionHistory/search',
      request
    );
    return response.data;
  }

  async getRecentExecutions(
    userId: string,
    limit: number = 20
  ): Promise<ExecutionHistorySummary[]> {
    const response = await authenticatedAxios.get<ExecutionHistorySummary[]>(
      '/ExecutionHistory/recent',
      {
        params: { userId, limit },
      }
    );
    return response.data;
  }

  async replayExecution(executionId: string): Promise<void> {
    await authenticatedAxios.post(
      `/ExecutionHistory/${executionId}/replay`
    );
  }

  async clearAllHistory(password: string): Promise<{ deletedCount: number; message: string }> {
    const response = await authenticatedAxios.delete<{ deletedCount: number; message: string }>(
      '/ExecutionHistory/clear',
      {
        data: { password },
      }
    );
    return response.data;
  }

  async getScoresBatch(executionIds: string[]): Promise<Record<string, ExecutionScoreSummary>> {
    const response = await authenticatedAxios.post<Record<string, ExecutionScoreSummary>>(
      '/execution-scores/batch',
      { executionIds }
    );
    return response.data;
  }
}
